module.exports = __webpack_public_path__ + "static/img/login-top-bg.c1e268dc.jpg";